import { 
  RiPlayCircleFill,
  RiPauseCircleFill,
  RiSkipBackFill,
  RiSkipForwardFill,
  RiRepeat2Fill,
  RiShuffleLine,
  RiRepeatOneLine
} from "react-icons/ri";
import { 
  sendLoop,
  sendPause,
  sendPrevious,
  sendResume, 
  sendShuffle, 
  sendSkip 
} from '../function'
import panel from '../styles/panel.module.scss'
import { motion } from "framer-motion"

const MenuPage = ({ 
  client, 
  playerGuild, 
  current, 
  pause, 
  loop, 
  res, 
  member, 
  user,
  queue
}: any) => {

  const artwork = current ? `${current.thumbnail}` : '/no_music.png'

  function copyText(title: string) {
    navigator.clipboard.writeText(title);
  }

  return (
    <>
      <div className={panel.panel} checked-color="a">
        <div className={panel.controller}>
          <div className={panel.info}>
            <div className={panel.picture}>
              {current ? (
                <motion.img 
                src={artwork} 
                className={panel.artwork} 
                alt={`Artwork`}
                initial={current ? true : false}
                animate={{
                  rotate: 360,
                }}
                transition={{ ease: "linear", duration: 20, repeat: Infinity }}/>
              ) : (
                <img src={artwork} className={panel.artwork} alt={`Artwork`}/>
              )}
            </div>
            <motion.div className={panel.info_hidden} onClick={() => copyText(current.title || "")} whileTap={{ scale: 0.95 }}>
              <h1 className={panel.title_margin}>{current ? current.title : "No tracks playing!"}</h1>
            </motion.div>
          </div>

          <div className={panel.control_player}>
            <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendPrevious(client, playerGuild)}>
              <RiSkipBackFill size={50} color="#ffffff"/>
            </motion.div>
            {
              !pause ? 
              <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendPause(client, playerGuild)}>
                <RiPauseCircleFill size={60} color="#ffffff"/>
              </motion.div>
              : <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendResume(client, playerGuild)}>
                <RiPlayCircleFill size={60} color="#ffffff"/>
              </motion.div> 
            }
            <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendSkip(client, playerGuild)}>
              <RiSkipForwardFill size={50} color="#ffffff"/> 
            </motion.div> 
          </div> 
    
          <div className={panel.option}>
            <div className={panel.extend}>
              <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendLoop(client, playerGuild, loop)}>
                {
                  loop === "track" ? <RiRepeatOneLine size={50} color="#ffffff"/>
                  : <RiRepeat2Fill size={50} color={loop === "queue" ? "#ffffff" : "#585858"} />
                }
              </motion.div>
              <motion.div  whileTap={{ scale: 0.9 }} onClick={() => sendShuffle(client, playerGuild)}>
                <RiShuffleLine size={50} color="#ffffff" />
              </motion.div>
            </div>
          </div>

        </div>
      </div>
    </>
  )
}

export default MenuPage